<template>
  <div class="Revealer" :class="elClass">

    <div class="Revealer-content">

      <div class="Revealer-image"
        @click="isRevealed = !isRevealed">

        <expander class="Revealer-expander"
          v-if="!disabled"
          :active="isRevealed" />

          <img class="Revealer-imageImage"
            :src="image" />

      </div>

      <div class="Revealer-text">

        <div class="Revealer-textItem"
          v-if="content.title1 || content.description1">

          <p class="Revealer-textItemHeader t-headingXs"
            v-if="content.title1"
            v-html="content.title1">
          </p>

          <p class="Revealer-textItemBody t-xSmall"
            v-if="content.description1"
            v-html="content.description1">
          </p>

        </div>

        <div class="Revealer-textItem"
          v-if="content.title2 || content.description2">

          <p class="Revealer-textItemHeader t-headingXs"
            v-if="content.title2"
            v-html="content.title2">
          </p>

          <p class="Revealer-textItemBody t-xSmall"
            v-if="content.description2"
            v-html="content.description2">
          </p>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import Expander from 'components/Expander'

export default {
  name: 'Revealer',

  components: {
    Expander
  },

  props: {
    image: {
      type: String,
      required: true
    },
    content: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isRevealed: false
    }
  },

  watch: {
    disabled () {
      if (this.disabled) {
        this.isRevealed = false
      }
    }
  },

  computed: {
    elClass () {
      return {
        'Revealer--isRevealed': this.isRevealed
      }
    }
  }
}
</script>

<style>
.Revealer {
  width: 655px;
  height: 371px;
  /*outline: 2px solid red;*/
}

.Revealer-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/**
 * Image must be fixed width, as of now.
 */
.Revealer-image {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 450px;
  transition: all 0.5s ease;
  /*outline: 2px solid blue;*/
}

.Revealer-expander {
  position: absolute;
  z-index: 900;
}

.Revealer-imageImage {
  display: block;
  max-width: 100%;
  max-height: 461px;
}

.Revealer--isRevealed .Revealer-image {
  transform: translate3d(-102px, 0, 0);
}

.Revealer-text {
  position: absolute;
  width: 205px;
  text-align: left;
  opacity: 0;
  transition: all 0.5s ease;
  transform: translate3d(226px, 0, 0) scale(0.9);
  /*outline: 1px solid green;*/
  pointer-events: none;
}

.Revealer--isRevealed .Revealer-text {
  opacity: 1;
  transform: translate3d(226px, 0, 0) scale(1);
}

.Revealer-textItem {

}

.Revealer-textItem + .Revealer-textItem {
  margin-top: 2rem;
}

.Revealer-textItemHeader {
  color: var(--color-5);
}

.Revealer-textItemHeader + .Revealer-textItemBody {
  margin-top: 0.5rem;
}

.Revealer-textItemBody {

}
</style>



// WEBPACK FOOTER //
// Revealer.vue?2e397528